import { useServices } from "./useServices.js";
const useImageConverter = ()=>useServices().imageConverter;
export { useImageConverter };
